module.exports = __webpack_public_path__ + "media/components/signup/static/icon-check--white-851117caf8dce4bb029ccc338395f594.svg";